import {ConfigText} from 'components/common/ConfigText'
import {Step} from '../Step/Step'
import {MaximizedOptions} from './MaximizedOptions'
import {MinimizedOptions} from './MinimizedOptions'

export const Options = () => {
  return (
    <Step
      caption={<ConfigText configKey="optionsCaption" defaultText="Which tour suits you best?" />}
      title={<ConfigText configKey="optionsTitle" defaultText="Tour" />}
      thisStepCode="option"
      minimizedComponent={MinimizedOptions}
      maximizedComponent={MaximizedOptions}
    />
  )
}
